import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabaseClient.ts';
import './NewsletterMobile.css';

function NewsletterMobile() {
  const [sectionData, setSectionData] = useState(null);
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  useEffect(() => {
    const fetchSectionData = async () => {
      const { data, error } = await supabase
        .from('newsletter_section')
        .select('*')
        .limit(1)
        .single();

      if (!error) {
        setSectionData(data);
      }
    };
    fetchSectionData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      setMessage({ type: 'error', text: 'Veuillez entrer une adresse email' });
      return;
    }

    setLoading(true);

    try {
      const { error } = await supabase
        .from('newsletter_subscribers')
        .insert([{ email: email.toLowerCase() }]);

      if (error) {
        if (error.code === '23505') {
          setMessage({ type: 'info', text: 'Cette adresse est déjà inscrite' });
        } else {
          setMessage({ type: 'error', text: 'Une erreur est survenue. Veuillez réessayer.' });
        }
      } else {
        setMessage({ type: 'success', text: 'Merci de votre inscription !' });
        setEmail('');
        setTimeout(() => setMessage({ type: '', text: '' }), 5000);
      }
    } catch (err) {
      setMessage({ type: 'error', text: 'Erreur de connexion' });
    } finally {
      setLoading(false);
    }
  };

  return sectionData ? (
    <div className="newsletter-mobile-container">
      <div className="newsletter-mobile-card">
        {/* Background Image */}
        <div className="newsletter-mobile-bg">
          <img
            src={sectionData.image_url || "../img/images/mask.png"}
            alt="Newsletter Background"
          />
          {/* Overlay */}
          <div className="newsletter-mobile-overlay"></div>
        </div>

        {/* Content */}
        <div className="newsletter-mobile-content">
          {/* Icon/Badge */}
          <div className="newsletter-mobile-icon">
            <svg
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
              <polyline points="22,6 12,13 2,6"></polyline>
            </svg>
          </div>

          {/* Title */}
          <h2 className="newsletter-mobile-title">
            {sectionData.title}
          </h2>

          {/* Subtitle */}
          <p className="newsletter-mobile-subtitle">
            <span className="asterisk">*</span>
            {sectionData.subtitle}
          </p>

          {/* Form */}
          <form onSubmit={handleSubmit} className="newsletter-mobile-form">
            <div className="newsletter-mobile-input-group">
              <input
                type="email"
                placeholder="Votre email..."
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
                className="newsletter-mobile-input"
              />
              <button
                type="submit"
                className="newsletter-mobile-button"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-small"></span>
                    Envoi...
                  </>
                ) : (
                  <>
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <line x1="22" y1="2" x2="11" y2="13"></line>
                      <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                    </svg>
                    Envoyer
                  </>
                )}
              </button>
            </div>

            {/* Message */}
            {message.text && (
              <div className={`newsletter-mobile-message ${message.type}`}>
                <span className="message-icon">
                  {message.type === 'success' && '✓'}
                  {message.type === 'error' && '✕'}
                  {message.type === 'info' && 'ℹ'}
                </span>
                <span className="message-text">{message.text}</span>
              </div>
            )}
          </form>

          {/* Footer Text */}
          <p className="newsletter-mobile-footer">
            Pas de spam, juste les meilleures offres
          </p>
        </div>
      </div>
    </div>
  ) : null;
}

export default NewsletterMobile;